// Toast + campainha + notificacao de SO pra mensagem nova, mesmo com a aba
// em segundo plano. Nao depende de nenhum arquivo de audio (webpack 4 +
// asset pipeline antigo deste projeto) - o "ding-dong" e sintetizado na
// hora via Web Audio API.

export function pedirPermissaoNotificacao() {
  if ('Notification' in window && Notification.permission === 'default') {
    // Precisa ser chamado a partir de uma interacao do usuario em navegadores
    // recentes - por isso so pedimos, nunca insistimos/bloqueamos por causa disso.
    Notification.requestPermission().catch(() => {})
  }
}

export function tocarCampainha() {
  try {
    const ContextoAudio = window.AudioContext || window.webkitAudioContext
    if (!ContextoAudio) return
    const contexto = new ContextoAudio()

    const tocarTom = (frequencia, inicio, duracao) => {
      const oscilador = contexto.createOscillator()
      const ganho = contexto.createGain()
      oscilador.type = 'sine'
      oscilador.frequency.value = frequencia
      oscilador.connect(ganho)
      ganho.connect(contexto.destination)
      ganho.gain.setValueAtTime(0.0001, contexto.currentTime + inicio)
      ganho.gain.exponentialRampToValueAtTime(0.35, contexto.currentTime + inicio + 0.02)
      ganho.gain.exponentialRampToValueAtTime(0.0001, contexto.currentTime + inicio + duracao)
      oscilador.start(contexto.currentTime + inicio)
      oscilador.stop(contexto.currentTime + inicio + duracao + 0.05)
    }

    tocarTom(880, 0, 0.28)
    tocarTom(659, 0.26, 0.42)
  } catch (erro) {
    // navegador sem Web Audio, ou politica de autoplay bloqueando - silencioso
  }
}

/**
 * @param {string} titulo
 * @param {string} corpo
 */
export function notificarSistemaOperacional(titulo, corpo) {
  if (!document.hidden) return // usuario esta com a aba em foco - o toast in-app ja resolve
  if (!('Notification' in window) || Notification.permission !== 'granted') return

  try {
    new Notification(titulo, { body: corpo, tag: 'punhus-atendimento', renotify: true })
  } catch (erro) {
    // alguns navegadores mobile nao suportam o construtor direto - sem problema, so o som ja ajuda
  }
}
